import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppDispatch } from '../../store/hooks'
import { buildRelativePath, PathConfig } from '../../core/config/PathConfig'
import AnalyticDetailsLayout from '../../components/analytics-details-v2/AnalyticDetailsLayout'
import GetChroniqueurById from '../../core/api/services/bookmetrie/private-reports/chroniqueur/get-chronique.service'
import { ChroniqueurResponseInterface } from '../../core/interface/chronique.interface'
import ChroniqueurViewSwitch from '../../components/chroniqueur/chronique-view/ChroniqueurViewSwitch'
import { patchReportService } from '../../core/api/services/bookmetrie/reports.service'
import { setShowSnackBar } from '../../store/reducers/web-app.reducer'

const ChroniqueurView = () => {
  const { chroniqueurId } = useParams<{ chroniqueurId: string }>()
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [chronique, setChronique] =
    useState<ChroniqueurResponseInterface | null>(null)

  useEffect(() => {
    if (!chroniqueurId) return
    setIsLoading(true)
    GetChroniqueurById(chroniqueurId)
      .then((response) => {
        setChronique(response.data)
      })
      .catch(() => {
        dispatch(setShowSnackBar(t('snackbarMessage.errorMessage')))
      })
      .finally(() => setIsLoading(false))
  }, [])

  const backToPrivateReports = () => {
    navigate(
      buildRelativePath([PathConfig.BOOKMETRIE, PathConfig.PRIVATE_REPORTS]),
    )
  }

  const handleRenameAnalytic = (name: string) => {
    if (!chroniqueurId) return
    patchReportService(chroniqueurId, { name })
      .then(() => {
        dispatch(
          setShowSnackBar(
            t('snackbarMessage.renameReportConfirm', {
              reportName: name,
            }),
          ),
        )
      })
      .catch(() => {
        dispatch(setShowSnackBar(t('snackbarMessage.errorMessage')))
      })
  }

  return (
    <AnalyticDetailsLayout
      analyticName={chronique?.report_name || ''}
      handleRenameAnalytic={handleRenameAnalytic}
      handleExitAnalyticDetails={backToPrivateReports}
      isLoading={isLoading}
      hasButtonPrevious={false}
    >
      {chronique && chroniqueurId ? (
        <ChroniqueurViewSwitch
          reportId={chroniqueurId}
          chronique={chronique}
          setChronique={setChronique}
        />
      ) : null}
    </AnalyticDetailsLayout>
  )
}

export default ChroniqueurView
